/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Login_Remove_BodyInputs */



/**
* | output |
* | --- |
* | "You will no longer be able to sign in with it. Your other logins are kept." |
*
* @param {Profile_Login_Remove_BodyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_login_remove_body = /** @type {((inputs?: Profile_Login_Remove_BodyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Login_Remove_BodyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous ne pourrez plus vous connecter avec. Vos autres accès sont conservés.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ya no podrás iniciar sesión con él. Tus otros accesos se conservan.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Você não poderá mais entrar com ele. Seus outros acessos são mantidos.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non potrai più accedere con esso. Gli altri accessi restano.")
	return /** @type {LocalizedString} */ ("You will no longer be able to sign in with it. Your other logins are kept.")
});